<app-section
  titleSection="Présentation de l'organisme"
  [isLargeTitle]="true"
  [isActivated]="organisme.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-notre-organisme-read-mode
      [organisme]="organismeInternal"
      [organismePhoto]="organismePhotoInternal"
      [organismeLogo]="organismeLogoInternal"
    >
    </app-notre-organisme-read-mode>
  </div>

  <div edit-mode>
    <app-notre-organisme-edit-mode
      [organisme]="organismeInternal"
      [reportId]="reportId"
      [organismePhoto]="organismePhotoInternal"
      [organismeLogo]="organismeLogoInternal"
      (organismeChanged)="onOrganismeChanged($event)"
      (clearLogo)="onClearLogo()"
      (clearPhoto)="onClearPhoto()"
      (changePhoto)="onChangePhoto($event)"
      (changeLogo)="onChangeLogo($event)"
    >
    </app-notre-organisme-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
